import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import ScrollLock, { TouchScrollable } from "react-scrolllock";
import close from "../img/close.png";
import Title from "./ModalTitle";
import arrowNext from "../img/arrow-next.png";
import arrowPrev from "../img/arrow-prev.png";
import Speakers from "./ModalSpeaker";
import device from "../helpers/device";
import { withRouter, Redirect, Link } from "react-router-dom";
import nl2br from "react-nl2br";
import Linkify from "react-linkify";
import { timeImg } from "../assetManager";

const modalRoot = document.getElementById("modal-root");

class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.contentRef = React.createRef();
  }

  calcHeight = () => {
    const dom = this.contentRef.current;
    const height = dom.offsetHeight || dom.clientHeight;
    const $el = document.getElementById("modal-wrapper");
    if (height >= window.innerHeight) {
      $el.classList.add("over");
    } else {
      $el.classList.remove("over");
    }
  };

  componentDidMount() {
    modalRoot.appendChild(this.el);
    this.calcHeight();
  }

  componentDidUpdate() {
    this.calcHeight();
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  getSession(dir) {
    const { sessions } = this.props.store;
    const mySessionId = this.props.match.params.sessionId;
    const currentIndex = sessions.indexOf(mySessionId);
    const size = sessions.length;
    if (dir === "next") {
      if (currentIndex + 1 >= size) {
        return sessions[0];
      }
      return sessions[currentIndex + 1];
    } else {
      if (currentIndex === 0) {
        return sessions[size - 1];
      }
      return sessions[currentIndex - 1];
    }
  }

  handleClose = () => {
    this.props.history.push("/");
  };

  render() {
    const entities = this.props.store.entities;
    const sessionId = this.props.match.params.sessionId;
    const myData = this.props.store.entities.sessions[sessionId];
    const myCategory = entities.categories[myData.category];
    const speackers = myData.speakers
      .map(speakerId => {
        return entities.speakers[speakerId] || undefined;
      })
      .filter(speaker => !!speaker);

    if (!myData) {
      return <Redirect to="/" />;
    }

    return ReactDOM.createPortal(
      <ScrollLock isActive={true}>
        <Fragment>
          <Background onClick={this.handleClose} />
          <TouchScrollable>
            <Root id="modal-wrapper">
              <div className="inner">
                <div className="inner">
                  <Contents ref={this.contentRef}>
                    <div className="close">
                      <img
                        onClick={this.handleClose}
                        src={close}
                        width="19"
                        alt=""
                      />
                    </div>
                    <div className="contents-inner">
                      <div className="time">
                        <img
                          src={timeImg[`time_${myData.scheduleId}`]}
                          width="125"
                          alt=""
                        />
                      </div>
                      <Title hallId={myData.hallId} category={myCategory}>
                        {nl2br(myData.title)}
                      </Title>
                      <div className="summary">
                        <Linkify properties={{ target: "_blank" }}>
                          {nl2br(myData.summary)}
                        </Linkify>
                      </div>
                      <Speakers speackers={speackers} />
                    </div>
                    <Nav>
                      <li>
                        <Link to={`/sessions/${this.getSession("prev")}`}>
                          <img src={arrowPrev} width="11" alt="前へ" />
                        </Link>
                      </li>
                      <li>
                        <Link to={`/sessions/${this.getSession("next")}`}>
                          <img src={arrowNext} width="11" alt="次へ" />
                        </Link>
                      </li>
                    </Nav>
                  </Contents>
                </div>
              </div>
            </Root>
          </TouchScrollable>
        </Fragment>
      </ScrollLock>,
      this.el
    );
  }
}

export default withRouter(Modal);

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const Root = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: none;
  &.over {
    /* 画面からはみ出すとき */
    pointer-events: auto;
    @media ${device.mobileL} {
      pointer-events: none;
    }
    > .inner {
      display: block;
    }
  }
  > .inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 600px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    > .inner {
      width: 100%;
      @media ${device.mobileL} {
        width: 600px;
      }
    }
  }
  .close {
    text-align: right;
    padding: 10px;
    pointer-events: auto;
    img {
      cursor: pointer;
    }
    @media ${device.mobileL} {
      position: relative;
      top: 40px;
      right: -55px;
      img {
        width: 27px;
      }
    }
  }
`;

const Contents = styled.div`
  > .contents-inner {
    background: #fff;
    border-radius: 10px;
    width: 100%;
    padding: 20px;
    position: relative;
    pointer-events: auto;
    @media ${device.mobileL} {
      padding: 40px;
    }
  }
  .time {
    margin-bottom: 10px;
    @media ${device.mobileL} {
      img {
        width: 160px;
      }
    }
  }
  .summary {
    font-size: 12px;
    padding: 15px 0;
    word-break: break-all;
    @media ${device.mobileL} {
      font-size: 14px;
      padding: 30px 0;
    }
  }
`;

const Nav = styled.ul`
  display: flex;
  justify-content: center;
  pointer-events: auto;
  @media ${device.mobileL} {
    position: absolute;
    top: 50%;
    width: 120%;
    margin-left: -10%;
    justify-content: space-between;
    pointer-events: none;
  }
  li {
    cursor: pointer;
    pointer-events: auto;
    > a {
      display: block;
      padding: 15px 30px;
    }
  }
`;
